<template>
    <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    custom-class="login-modal"
    @close="$emit('close')">
        <span>{{ text }}</span>
        <span slot="footer" class="dialog-footer">
            <el-button label-width="200" @click="$emit('close')">キャンセル</el-button>
            <el-button label-width="200" type="primary" @click="$emit('login')">ログインする</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: 'ログイン',
            text: '詳細を閲覧する場合はログインしてください'
        }
    }
}
</script>

<style>
.login-modal {
    width: 80% !important;
    max-width: 400px !important;
}
</style>